<template>
    <div>
        <ollaHead class="header" :isScroll="isScroll" @changeShowAddr="changeShowAddr"></ollaHead>

        <div class="indexMain">
            <div class="main1">
                <div class="main1_t1">OLLA<br>您的海外生活助手</div>
                <div class="main1_t2">
                    提供优质、便捷的生活服务，帮助您轻松应对生活海外日常琐事，能够专注于生活中更重要的事情。致力于打造一个充满温暖与关怀的平台，让您在忙碌的生活中感受到如家般的舒适与安心。
                </div>
                <div class="d-f tabs">
                    <div @click="scrollToAnchor('souji')" class="main1_tab">
                        <img src="../../assets/icon_clean.png"/>
                        <div class="tab_text">CLEAN</div>
                    </div>
                    <div @click="scrollToAnchor('repair')" class="main1_tab">
                        <img src="../../assets/icon_repair.png"/>
                        <div class="tab_text">REPAIR</div>
                    </div>
                    <div @click="scrollToAnchor('run')" class="main1_tab">
                        <img src="../../assets/icon_run.png"/>
                        <div class="tab_text">RUN</div>
                    </div>
                    <div @click="scrollToAnchor('chef')" class="main1_tab">
                        <img src="../../assets/icon_chef.png"/>
                        <div class="tab_text">CHEF</div>
                    </div>
                    <div @click="scrollToAnchor('pets')" class="main1_tab">
                        <img src="../../assets/icon_pets.png"/>
                        <div class="tab_text">PETS</div>
                    </div>
                </div>
            </div>

            <div class="d-f tabTitle">
                <img class="iconTitle" src="../../assets/icon_title.png"/>
                <div class="titleText">特色服务</div>
                <img class="iconTitle" src="../../assets/icon_title.png"/>
            </div>

            <div id="souji" class="souji divSouji">
                <div class="divSouji_d1">
                    <div class="soujiTop">
                        <img src="../../assets/souji_img_1.png"/>
                        <div>OLLA CLEAN — 您的家庭清洁专家</div>
                        <div>致力于为您提供高效、专业的清洁解决方案。无论是日常保洁、深度清洁，还是需要专业设备和技术支持的清洁任务，OLLA
                            CLEAN都将为您的家庭带来焕然一新的清洁体验。
                        </div>
                    </div>
                    <img class="contextImg" src="../../assets/souji_img_5.png"/>
                </div>
                <div class="serveBoxs">
                    <div class="serveBox">
                        <div class="d-f p-r serveBoxTop">
                            <img src="../../assets/souji_img_2.png"/>
                            <div>日常清洁</div>
                            <div style="cursor: pointer;" @click="changeShowContext('clean-1')">服务内容</div>
                        </div>
                        <div class="serveBoxbottom">
                            <div class="serveContext">
                                为您提供日常生活中所需的基础清洁服务，确保居家环境的整洁与卫生。我们的团队将根据您的需求，快速、高效地完成清洁工作，帮助您保持舒适的居住环境。
                            </div>
                            <div class="servePrice">
                                <div class="f-1">￥<span>3300</span>円/小时(含税)起</div>
                                <div style="cursor: pointer;" @click="changeShowPrice('clean-1')">价格说明</div>
                            </div>
                        </div>
                    </div>

                    <div class="serveBox">
                        <div class="d-f p-r serveBoxTop">
                            <img src="../../assets/souji_img_4.png"/>
                            <div>专业清洁</div>
                            <div style="cursor: pointer;" @click="changeShowContext('clean-3')">服务内容</div>
                        </div>
                        <div class="serveBoxbottom">
                            <div class="serveContext">
                                专业家电家具深度清洁服务，包含各类空调、油烟机、沙发、地毯及床铺。彻底除尘除菌去螨，高效去污，让家居焕然一新。预约方便，服务细致，为您打造清新健康的居家环境！
                            </div>
                            <div class="servePrice">
                                <div class="f-1">￥<span>9900</span>円/件(含税)起</div>
                                <div style="cursor: pointer;" @click="changeShowPrice('clean-3')">价格说明</div>
                            </div>
                        </div>
                    </div>

                    <div class="serveBox">
                        <div class="d-f p-r serveBoxTop">
                            <img src="../../assets/souji_img_3.png"/>
                            <div>深度清洁</div>
                            <div style="cursor: pointer;" @click="changeShowContext('clean-2')">服务内容</div>
                        </div>
                        <div class="serveBoxbottom">
                            <div class="serveContext">
                                针对那些日常难以打扫或不经常清理的区域，我们提供专业的深度清洁服务。使用专业工具以及专用清洁剂、消毒剂等，对家居进行全面护理，确保持久的清洁与保养效果。
                            </div>
                            <div class="servePrice">
                                <div class="f-1">￥<span>4500</span>円/小时(含税)起</div>
                                <div style="cursor: pointer;" @click="changeShowPrice('clean-2')">价格说明</div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>

            <div id="repair" class="repair divRun">
                <div class="divSouji_d1">
                    <div class="runTop">
                        <img src="../../assets/repair_img_1.png"/>
                        <div>OLLA REPAIR — 可靠的家居安装与维修专家</div>
                        <div>专注于家电、家具、水电气等设备的专业安装与维修服务。我们的团队由经验丰富的技师组成，致力于为您提供高效、可靠的服务，确保您的家居设备正常运转，让您的生活更加舒适便捷。
                        </div>
                    </div>
                    <img class="contextImg" src="../../assets/repair_img_2.png"/>
                </div>
                <div class="serveBoxs">
                    <div class="serveBox">
                        <div class="d-f p-r serveBoxTop">
                            <img src="../../assets/repair_img_3.png"/>
                            <div>安装维修</div>
                            <div style="cursor: pointer;" @click="changeShowContext('repair-1')">服务内容</div>
                        </div>
                        <div class="serveBoxbottom">
                            <div class="serveContext">
                                涵盖家电、家具、水电气等各类设备，确保每项安装工作都符合安全和功能要求。
                            </div>
                            <div class="servePrice">
                                <div class="f-1">价格详谈</div>
                                <div style="cursor: pointer;" @click="changeShowPrice('repair-1')">价格说明</div>
                            </div>
                        </div>
                    </div>
                    <div class="serveBox">
                        <div class="d-f p-r serveBoxTop">
                            <img src="../../assets/repair_img_4.png"/>
                            <div>管道疏通</div>
                            <div style="cursor: pointer;" @click="changeShowContext('repair-2')">服务内容</div>
                        </div>
                        <div class="serveBoxbottom">
                            <div class="serveContext">
                            单管/总管/水道井，高压机械彻底清理，24小时上门，快速解决堵塞问题！
                            </div>
                            <div class="servePrice">
                                <div class="f-1">价格详谈</div>
                                <div style="cursor: pointer;" @click="changeShowPrice('repair-2')">价格说明</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="run" class="run divRun">
                <div class="divSouji_d1">
                    <div class="runTop">
                        <img src="../../assets/run_img_2.png"/>
                        <div>OLLA RUN — 您的生活助理，跑腿代办轻松搞定</div>
                        <div>专注于家庭跑腿和事务代办的专业服务，致力于为您解决日常琐事和复杂事务。无论是生活购物、文件递送，还是紧急情况处理，我们都能为您提供快速、高效的服务，让您省心省力，享受无忧生活。
                        </div>
                    </div>
                    <img class="contextImg" src="../../assets/run_img_1.png"/>
                </div>
                <div class="serveBoxs">
                    <div class="serveBox">
                        <div class="d-f p-r serveBoxTop">
                            <img src="../../assets/run_img_3.png"/>
                            <div>跑腿服务</div>
                            <div style="cursor: pointer;" @click="changeShowContext('run-1')">服务内容</div>
                        </div>
                        <div class="serveBoxbottom">
                            <div class="serveContext">
                                覆盖广泛的日常需求，为您提供便捷、快速的解决方案，让您无需亲自奔波。
                            </div>
                            <div class="servePrice">
                                <div class="f-1">￥<span>2000</span>円/小时(含税)起</div>
                                <div style="cursor: pointer;" @click="changeShowPrice('run-1')">价格说明</div>
                            </div>
                        </div>
                    </div>
                    <div class="serveBox">
                        <div class="d-f p-r serveBoxTop">
                            <img src="../../assets/run_img_4.png"/>
                            <div>代办服务</div>
                            <div style="cursor: pointer;" @click="changeShowContext('run-2')">服务内容</div>
                        </div>
                        <div class="serveBoxbottom">
                            <div class="serveContext">
                                覆盖多项事务处理，专业、高效地解决您在日常生活中的繁杂事务。
                            </div>
                            <div class="servePrice">
                                <div class="f-1">￥<span>2000</span>円/小时(含税)起</div>
                                <div style="cursor: pointer;" @click="changeShowPrice('run-2')">价格说明</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="chef" class="chef divRun">
                <div class="divSouji_d1">
                    <div class="runTop">
                        <img src="../../assets/chef_img_1.png"/>
                        <div>OLLA CHEF — 您的私人厨师服务，定制美食体验</div>
                        <div>提供高端的私人厨师服务，为您和您的家人提供个性化餐饮体验。无论是日常用餐、家庭聚餐，还是特别节日庆典，我们的厨师团队都将为您精心烹制美味菜肴，让您在家中即可享受五星级餐饮服务。
                        </div>
                    </div>
                    <img class="contextImg" src="../../assets/chef_img_2.png"/>
                </div>
                <div class="serveBoxs">
                    <div class="serveBox">
                        <div class="d-f p-r serveBoxTop">
                            <img src="../../assets/chef_img_3.png"/>
                            <div>私人厨师上门服务</div>
                            <div style="cursor: pointer;" @click="changeShowContext('chef-1')">服务内容</div>
                        </div>
                        <div class="serveBoxbottom">
                            <div class="serveContext">
                                让您不必出门便可享受定制餐饮体验，满足您的日常或特殊餐饮需求。
                            </div>
                            <div class="servePrice">
                                <div class="f-1">￥<span>2000</span>円/小时(含税)起</div>
                                <div style="cursor: pointer;" @click="changeShowPrice('chef-1')">价格说明</div>
                            </div>
                        </div>
                    </div>
                    <div class="serveBox">
                        <div class="d-f p-r serveBoxTop">
                            <img src="../../assets/chef_img_4.png"/>
                            <div>司机月嫂住家保姆</div>
                            <div style="cursor: pointer;" >服务内容</div>
                        </div>
                        <div class="serveBoxbottom">
                            <div class="serveContext">
司机、月嫂、住家保姆，持证上岗，定制需求，安心省心,全程无忧。
                            </div>
                            <div class="servePrice">
                                <div class="f-1">￥<span>2000</span>円/小时(含税)起</div>
                                <div style="cursor: pointer;" >价格说明</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="pets" class="pets divRun">
                <div class="divSouji_d1">
                    <div class="runTop">
                        <img src="../../assets/pets_img_1.png"/>
                        <div>OLLA PETS — 宠物看护专家，一起守护您的宠物</div>
                        <div>专为宠物提供专业的服务。无论您是短暂出差、度假，还是工作繁忙，我们都能为您的宠物提供全方位的照顾与陪伴，确保它们的身心健康和快乐。
                        </div>
                    </div>
                    <img class="contextImg" src="../../assets/pets_img_2.png"/>
                </div>
                <div class="serveBoxs">
                    <div class="serveBox">
                        <div class="d-f p-r serveBoxTop">
                            <img src="../../assets/pets_img_3.png"/>
                            <div>宠物喂养服务</div>
                            <div style="cursor: pointer;" @click="changeShowContext('pets-1')">服务内容</div>
                        </div>
                        <div class="serveBoxbottom">
                            <div class="serveContext">
                                在您外出期间，OLLA PETS为您的宠物提供安全、舒适的喂养环境。我们的专业人员上门喂养，确保它们得到悉心的照料，包括定时喂食、活动和卫生护理。您可以放心外出，宠物将在我们温馨的环境中度过轻松愉快的时光。
                            </div>
                            <div class="servePrice">
                                <div class="f-1">￥<span>2800</span>円/小时(含税)起</div>
                                <div style="cursor: pointer;" @click="changeShowPrice('pets-1')">价格说明</div>
                            </div>
                        </div>
                    </div>
                    <div class="serveBox">
                        <div class="d-f p-r serveBoxTop">
                            <img src="../../assets/pets_img_4.png"/>
                            <div>遛狗服务</div>
                            <div style="cursor: pointer;" @click="changeShowContext('pets-2')">服务内容</div>
                        </div>
                        <div class="serveBoxbottom">
                            <div class="serveContext">
                                对于忙碌的宠物主人，OLLA PETS提供遛狗服务。我们的专业团队会根据狗狗的日常需求，带它们外出散步或运动，确保它们获得足够的锻炼和户外活动时间。遛狗不仅能让狗狗保持身体健康，还能缓解它们的压力与焦虑，确保它们快乐而满足。
                            </div>
                            <div class="servePrice">
                                <div class="f-1">￥<span>2800</span>円/小时(含税)起</div>
                                <div style="cursor: pointer;" @click="changeShowPrice('pets-2')">价格说明</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-f tabTitle">
                <img class="iconTitle" src="../../assets/icon_title.png"/>
                <div class="titleText">社交媒体账号</div>
                <img class="iconTitle" src="../../assets/icon_title.png"/>
            </div>

            <div class="okerBottom">
                <img class="oker" src="../../assets/oker.png"/>
                <div class="b_d1">关注我们，发现更多精彩</div>
                <div class="b_d2">扫一扫关注OLLA小红书账号，获取最新资讯。加入我们的社群，随时随地分享生活灵感，发现更多美好瞬间！</div>
                <div class="qr qr_guanfang">
                    <img src="../../assets/qr_guanfang.png"/>
                    <div>OLLA 官方号</div>
                </div>

                <div class="qr qr_run">
                    <img src="../../assets/qr_guanfang2.png"/>
                    <div>OLLA CLEAN 官方号</div>
                </div>
            </div>
        </div>
    </div>

    <el-dialog
        v-model="showAddr"
        title=""
        :width="dialogWidth"
        center
    >
        <div slots="title" class="diaTitle">服务范围</div>
        <div v-for="item in addrs" v-bind:key="item">
            <div class="dialogCity">· {{ item.city }}</div>
            <div class="dialogArea">
                <span v-for="area in item.areas" v-bind:key="area">{{ area }} > </span>
            </div>
        </div>
    </el-dialog>

    <el-dialog
        v-model="showContext"
        title=""
        center
        :width="dialogWidth"
    >
        <div v-if="serveType=='clean-1'">
            <div slots="title" class="diaTitle">服务内容</div>
            <div>
                <div class="dialogBody">· 服务人员自带部分工具</div>
                <div class="dialogBody">· 除尘服务：使用吸尘器或静电吸尘工具去除房间各处的灰尘。</div>
                <div class="dialogBody">· 地板清扫：清扫、拖地、吸尘，保持地板整洁。</div>
                <div class="dialogBody">· 桌面和家具清洁：清理桌面、柜子、沙发等家具上的灰尘和污渍。</div>
                <div class="dialogBody">· 厨房清洁：清理灶台表面、橱柜表面、台面、洗碗槽，去除油渍、污垢。</div>
                <div class="dialogBody">· 浴室、洗面台、厕所清洁：清洁浴室、浴缸、马桶、洗手台等，去除水垢和霉菌。 部分水垢可能需要专业清洁处理。</div>
                <div class="dialogBody">· 垃圾清理：清除室内垃圾、垃圾袋更换、垃圾桶清洗。</div>
            </div>
        </div>
        <div v-if="serveType=='clean-2'">
            <div slots="title" class="diaTitle">服务内容</div>
            <div>
                <div class="dialogBody">· 服务人员自带部分工具</div>
                <div class="dialogBody">· 窗户清洁：清洗窗玻璃、窗框，去除积尘、污渍和水垢。</div>
                <div class="dialogBody">· 浴室玻璃清洁：清除顽固水垢和污渍。</div>
                <div class="dialogBody">· 阳台清洁：清理阳台地面、栏杆、窗户及阳台上的植物灰尘。</div>
                <div class="dialogBody">· 庭院和露台清洁：清扫庭院、露台，整理花园和户外家具。</div>
                <div class="dialogBody">· 墙壁和天花板清洁：清理墙面、天花板上的灰尘、蜘蛛网或污渍。</div>
                <div class="dialogBody">· 橱柜内部清洁：清理橱柜内部，整理和清洁物品。</div>
                <div class="dialogBody">· 特殊材质家具或装饰品的清洁保养。</div>
                <div class="dialogBody">· 植物除尘：清理家庭盆栽植物的叶片灰尘。</div>
            </div>
        </div>
        <div v-if="serveType=='clean-3'">
            <div slots="title" class="diaTitle">服务内容</div>
            <div>
                <div class="dialogBody">· 空调清洁：清洁空调过滤网、外壳，去除灰尘和霉菌</div>
                <div class="dialogBody">· 冰箱清洁：清理冰箱内部、去除异味、清理冷冻室。</div>
                <div class="dialogBody">· 烤箱和微波炉清洁：清理烤箱、微波炉内部的残留食物和油渍。</div>
                <div class="dialogBody">· 脱排油烟机、排气扇和通风口清洁：清除排气扇、通风口的灰尘和油脂。</div>
                <div class="dialogBody">· 地板打蜡与抛光。</div>
            </div>
        </div>
        <div v-if="serveType=='run-1'">
            <div slots="title" class="diaTitle">服务内容</div>
            <div>
                <div class="dialogTitle">· 购物代办：</div>
                <div class="dialogBody">· 日用品代购：为您代购生活必需品，如食品、饮料、清洁用品等，并送货上门。</div>
                <div class="dialogBody">· 药品代购：为生病或不便出门的家庭成员代买药品，并提供送药上门服务。</div>
                <div class="dialogBody">· 超市购物：代为采购蔬菜、水果、肉类等生鲜食品。</div>
            </div>
            <div>
                <div class="dialogTitle">· 送递物品：</div>
                <div class="dialogBody">· 文件送递：帮助您递送重要文件或资料，确保安全、及时送达。</div>
                <div class="dialogBody">· 包裹投递：代为寄送包裹或接收包裹后转送到家中。</div>
                <div class="dialogBody">· 礼品递送：代送礼物或节日礼品，如生日礼物、节日祝福等，表达您的心意。</div>
            </div>
            <div>
                <div class="dialogTitle">· 餐饮代购：</div>
                <div class="dialogBody">· 外卖取餐：代为取回已点好的外卖食品并送到家中。</div>
                <div class="dialogBody">· 餐厅订餐：在家庭聚会或节日期间，我们代为前往餐厅订餐、取餐，让聚会更加轻松。</div>
            </div>
            <div>
                <div class="dialogTitle">· 日常事务：</div>
                <div class="dialogBody">· 维修服务联络：· 为您联系专业维修工人，并协助安排上门维修时间，解决家庭小修小补问题。</div>
                <div class="dialogBody">· 接送服务：代为短程接送物品，如取送修理好的电器、家具等。</div>
            </div>
            <div>
                <div class="dialogTitle">· 宠物代办：</div>
                <div class="dialogBody">· 宠物食品购买：为您的宠物采购日常所需的食品或用品。</div>
                <div class="dialogBody">· 宠物接送：帮助将宠物送到宠物医院、宠物美容店或寄养中心等。</div>
            </div>
            <div>
                <div class="dialogTitle">· 排队服务：</div>
                <div class="dialogBody">· 医院挂号：尤其是在看病高峰期或预约紧张时。</div>
                <div class="dialogBody">· 其他排队：代为排队等待热门场所或活动门票，如演唱会、展览等。</div>
            </div>
        </div>
        <div v-if="serveType=='run-2'">
            <div slots="title" class="diaTitle">服务内容</div>
            <div>
                <div class="dialogTitle">· 缴费代办：</div>
                <div class="dialogBody">· 水电费代缴：代为缴纳水、电、燃气等公共费用。</div>
                <div class="dialogBody">· 电话费和网络费代缴：代为处理电话费、网络费等缴费事务。</div>
                <div class="dialogBody">· 管理费代缴：代为缴纳房屋的物业费、停车费等管理费用。</div>
            </div>
            <div>
                <div class="dialogTitle">· 文件办理：</div>
                <div class="dialogBody">· 证件代办：帮助处理或递交证件申请，如身份证、护照、驾照等手续。</div>
                <div class="dialogBody">· 银行业务代办：代为处理银行事务，如转账、存取款、开设账户等（视银行政策而定）。</div>
            </div>
            <div>
                <div class="dialogTitle">· 行政代办：</div>
                <div class="dialogBody">· 签证办理：帮助您准备、提交签证所需材料，或处理相关签证事务。</div>
                <div class="dialogBody">· 税务代缴：协助递交或缴纳税款，处理相关税务文件，简化繁杂的税务流程。</div>
            </div>
            <div>
                <div class="dialogTitle">· 紧急事务代办：</div>
                <div class="dialogBody">· 突发故障处理：如家中突然断电或水管爆裂，迅速为您联系并安排维修人员。</div>
                <div class="dialogBody">· 应急物品购买：在紧急情况下，代购生活必需品、药品等。</div>
            </div>
        </div>
        <div v-if="serveType=='chef-1'">
            <div slots="title" class="diaTitle">服务内容</div>
            <div>
                <div class="dialogBody">· 日常餐饮：定期上门为您烹饪早餐、午餐或晚餐，提供从家常菜到高档美食的多样选择。</div>
                <div class="dialogBody">· 定制餐单：根据您的饮食偏好、健康需求和特殊要求（如素食、无糖饮食等）提供个性化菜单设计。</div>
                <div class="dialogBody">· 家庭聚餐服务：准备家庭聚会、生日宴会特别菜单，包含精美的前菜、主菜和甜点。</div>
                <div class="dialogBody">· 国际风味餐：为您呈现来自世界各地的美食风味，如法式大餐、日式料理、意大利美食等。</div>
            </div>
        </div>
        <div v-if="serveType=='chef-2'">
            <div slots="title" class="diaTitle">服务内容</div>
            <div>
                <div class="dialogBody">· 健康餐服务：为有特定健康需求的人群（如低盐、低脂、无麸质等）提供定制化餐饮服务。</div>
                <div class="dialogBody">· 儿童餐服务：专为孩子设计营养丰富且美味的餐单，帮助孩子摄取均衡的蔬菜、蛋白质和健康零食。</div>
                <div class="dialogBody">· 老年人餐饮：根据老年人的健康状况，提供易于消化且营养丰富的餐饮方案。</div>
            </div>
        </div>
        <div v-if="serveType=='pets-1'">
            <div slots="title" class="diaTitle">服务内容</div>
            <div>
                <div class="dialogBody">· 包括定时喂食、玩耍、散步、清理宠物活动区域。</div>
            </div>
            <div>
                <div class="dialogTitle">· 注意事项：</div>
                <div class="dialogBody">· 服务期间，宠物用品及食物由用户提供。</div>
            </div>
        </div>
        <div v-if="serveType=='pets-2'">
            <div slots="title" class="diaTitle">服务内容</div>
            <div>
                <div class="dialogBody">· 根据狗狗的需求进行散步或运动，确保其获得足够的锻炼和户外活动时间。</div>
            </div>
        </div>
        <div v-if="serveType=='repair-1'">
            <div slots="title" class="diaTitle">服务内容</div>
            <div>
                <div class="dialogTitle">· 家电安装：</div>
                <div class="dialogBody">· 电视：提供挂墙安装和调试服务。</div>
                <div class="dialogBody">· 空调：包括壁挂式和立式空调的安装及调试。</div>
                <div class="dialogBody">· 冰箱、洗衣机：负责接水、接电和调试。</div>
                <div class="dialogBody">· 厨房电器：包括抽油烟机、灶具、洗碗机、消毒柜的安装。</div>
            </div>
            <div>
                <div class="dialogTitle">· 家具安装：</div>
                <div class="dialogBody">· 组合家具：如床、沙发、柜子、桌椅等的组装与安装。</div>
                <div class="dialogBody">· 定制家具：提供定制衣柜、书柜等的安装服务。</div>
            </div>
            <div>
                <div class="dialogTitle">· 水电气安装：</div>
                <div class="dialogBody">· 水管安装与维修：包括厨房和浴室的水管连接与修复。</div>
                <div class="dialogBody">· 电气安装：开关、插座、灯具的安装和线路连接。</div>
                <div class="dialogBody">· 燃气安装：包括燃气管道和燃气热水器的安装。</div>
            </div>
            <div>
                <div class="dialogTitle">· 装修相关安装：</div>
                <div class="dialogBody">· 门窗安装：室内门、外门、窗户的安装。</div>
                <div class="dialogBody">· 地板安装：木地板、地砖等材料的铺设。</div>
                <div class="dialogBody">· 墙面处理：墙纸、瓷砖、涂料的施工与安装。</div>
            </div>
            <div>
                <div class="dialogTitle">· 网络和通讯设备安装：</div>
                <div class="dialogBody">· 路由器：无线网的设置和安装。</div>
                <div class="dialogBody">· 弱电系统：家庭影院、音响系统的布线和安装。</div>
            </div>
        </div>
        <div v-if="serveType=='repair-2'">
            <div slots="title" class="diaTitle">服务内容</div>
            <div>
                <div class="dialogTitle">· 家具维修：</div>
                <div class="dialogBody">· 木质家具：修补裂痕、划痕和表面磨损。</div>
                <div class="dialogBody">· 皮革家具：修复皮面裂缝、色差等问题。</div>
                <div class="dialogBody">· 组合家具：更换损坏的连接件、修复柜门下垂等问题。</div>
            </div>
            <div>
                <div class="dialogTitle">· 水电维修：</div>
                <div class="dialogBody">· 水管维修：处理水管破裂、堵塞、漏水等问题。</div>
                <div class="dialogBody">· 龙头和阀门：更换和维修漏水、松动等问题。</div>
                <div class="dialogBody">· 电路维修：解决断电、短路、插座失灵、电器跳闸等问题。</div>
                <div class="dialogBody">· 照明维修：维修灯具损坏、灯泡更换、开关失灵等问题。</div>
            </div>
            <div>
                <div class="dialogTitle">· 燃气维修：</div>
                <div class="dialogBody">· 燃气泄漏：检查、修复或更换燃气管道。</div>
                <div class="dialogBody">· 燃气热水器：维修燃气热水器的不点火、水温异常、漏水等问题。</div>
            </div>
            <div>
                <div class="dialogTitle">· 门窗维修：</div>
                <div class="dialogBody">· 门锁：解决门锁卡住、无法开启、锁芯更换等问题。</div>
                <div class="dialogBody">· 门窗框架：修复门窗变形、松动、无法正常开合等问题。</div>
                <div class="dialogBody">· 滑轨：维修移门或窗户滑轨卡滞、磨损问题。</div>
                <div class="dialogBody">· 密封问题：修补门窗漏风、漏水等问题，提升门窗的密封性能。</div>
            </div>
            <div>
                <div class="dialogTitle">· 墙体和地面维修：</div>
                <div class="dialogBody">· 墙面修复：修补墙面开裂、剥落、渗水等问题。</div>
                <div class="dialogBody">· 地板修复：维修木地板开裂、鼓起、划痕等问题。</div>
                <div class="dialogBody">· 瓷砖修补：修补瓷砖裂痕、脱落、破损等问题。</div>
            </div>
            <div>
                <div class="dialogTitle">· 卫浴设施维修：</div>
                <div class="dialogBody">· 马桶：处理马桶堵塞、漏水、冲水不畅等问题。</div>
                <div class="dialogBody">· 淋浴设备：维修花洒、水龙头、排水管堵塞或损坏问题。</div>
                <div class="dialogBody">· 浴室防水：修复地面和墙面渗水问题。</div>
            </div>
        </div>
    </el-dialog>

    <el-dialog
        v-model="showPrice"
        title=""
        :width="dialogWidth"
        center
    >
        <div v-if="serveType=='clean-1'">
            <div slots="title" class="diaTitle">
                价格说明-日常保洁
                <span style="color: #999999;">（含税）</span>
            </div>
            <div>
                <div class="dialogTitle">· 价格收费说明（含税）：</div>
                <div class="dialogBody">· 服务收费：3300円/小时。最少预订时长：2小时起订</div>
                <div class="dialogBody">· 交通费用：880円/每位服务人员</div>
                <div class="dialogBody">· 服务人员数量：通常1位服务人员。若您有特殊需求，可以在预约时说明，增加服务人员</div>
            </div>
            <div>
                <div class="dialogTitle">· 总费用示例：</div>
                <div class="dialogBody">· 2小时清洁服务：6600円 + 880円交通费 = 7480円</div>
                <div class="dialogBody">· 3小时清洁服务：9900円 + 880円交通费 = 10780円</div>
            </div>
            <div class="dialogRed">· 注：如有额外需求或长期清洁计划，请联系我们获取定制化报价。</div>
        </div>
        <div v-if="serveType=='clean-2'">
            <div slots="title" class="diaTitle">
                价格说明-深度清洁
                <span style="color: #999999;">（含税）</span>
            </div>
            <div>
                <div class="dialogTitle">· 价格收费说明（含税）：</div>
                <div class="dialogBody">· 服务收费：根据清洁项目的复杂度，费用从 4500円/小时 起。阳台以及露台根据面积计算，10平米以内8000日元，超过每10平米加4000日元。最少预订时长：2小时起订</div>
                <div class="dialogBody">· 交通费用：880円/每位服务人员</div>
                <div class="dialogBody">· 服务人员数量：通常派遣1位或2位服务人员，具体人数根据清洁区域大小及复杂度确定</div>
            </div>
            <div>
                <div class="dialogTitle">· 特殊项目收费（视情况额外收费）：</div>
                <div class="dialogBody">· 窗户清洁：根据窗户数量（面积）和难度，费用将根据现场评估提供详细报价</div>
                <div class="dialogBody">· 特殊材质家具保养：根据材质和保养难度，费用另议</div>
                <div class="dialogBody">· 庭院清洁：根据面积和清理内容，费用将根据现场评估提供详细报价</div>
            </div>
            <div>
                <div class="dialogTitle">· 总费用示例：</div>
                <div class="dialogBody">· 2小时深度清洁服务（1人）：9000円 + 880円交通费 = 9880円</div>
                <div class="dialogBody">· 3小时深度清洁服务（2人）：13500円 + 1760円交通费 = 15260円</div>
            </div>
        </div>
        <div v-if="serveType=='clean-3'">
            <div slots="title" class="diaTitle">
                价格说明-专业清洁
                <span style="color: #999999;">（含税）</span>
            </div>
            <div>
                <div class="dialogTitle">· 价格收费说明（含税）：</div>
                <div class="dialogBody">· 服务收费：冰箱、空调、烤箱等设备的清洁主要以计件收费为准</div>
                <div class="dialogBody">· 交通费用：880円/每位服务人员</div>
            </div>
            <div>
                <div class="dialogTitle">· 特殊项目收费：</div>
                <div class="dialogBody">· 冰箱清洁：9000円/台</div>
                <div class="dialogBody">· 挂式空调内机清洁：9800円/台，第二台起每台减2000円</div>
                <div class="dialogBody">· 空调外机清洁：3000円/台。第二台起每台减1000円</div>
                <div class="dialogBody">· 烤箱和微波炉清洁：3500円/台</div>
                <div class="dialogBody">· 脱排油烟机清洁：9800円/台</div>
                <div class="dialogBody">· 排气扇和通风口清洁：3500円/个</div>
                <div class="dialogBody">· 地板打蜡与抛光：根据面积和难度，具体费用需现场评估</div>
            </div>
            <div>
                <div class="dialogTitle">· 总费用示例：</div>
                <div class="dialogBody">· 冰箱清洁 + 交通费用：9000円 + 880円 = 9880円</div>
                <div class="dialogBody">· 挂式空调内机（2台）清洁 + 交通费用：17600円 + 880円 = 18480円</div>
            </div>
            <div class="dialogRed">· 注：所有专业清洁项目的具体价格和时长将根据设备状况及现场评估进行调整。请在预约时咨询详情。</div>
        </div>
        <div v-if="serveType=='run-1'">
            <div slots="title" class="diaTitle">
                价格说明-跑腿服务
                <span style="color: #999999;">（含税）</span>
            </div>
            <div>
                <div class="dialogTitle">· 价格收费说明（含税）：</div>
                <div class="dialogBody">· 基本服务费：2000円</div>
                <div class="dialogBody">· 每小时收费：3300円，第二小时起，不满半小时按半小时计算，超过半小时按一小时计算</div>
            </div>
            <div>
                <div class="dialogTitle">· 路费：</div>
                <div class="dialogBody">· 基础路费：880円，实际路费超出部分将根据实际情况另外结算</div>
            </div>
            <div>
                <div class="dialogTitle">· 其他费用：</div>
                <div class="dialogBody">· 买办代办时发生的其他费用需提前预先支付，如有剩余将在订单结束时一并退还</div>
            </div>
            <div>
                <div class="dialogTitle">· 总费用示例：</div>
                <div class="dialogBody">· 1小时代办服务：2000円基本服务费 + 3300円服务费 + 880円路费 = 6180円</div>
                <div class="dialogBody">· 2小时跑腿服务：2000円基本服务费 + 6600円服务费 + 880円路费 = 9480円</div>
            </div>
            <div class="dialogRed">· 注：具体费用将根据服务项目和实际路程确定，详情请在预约时咨询。</div>
        </div>
        <div v-if="serveType=='run-2'">
            <div slots="title" class="diaTitle">
                价格说明-代办服务
                <span style="color: #999999;">（含税）</span>
            </div>
            <div>
                <div class="dialogTitle">· 价格收费说明（含税）：</div>
                <div class="dialogBody">· 基本服务费：2000円</div>
                <div class="dialogBody">· 每小时收费：3300円，第二小时起，不满半小时按半小时计算，超过半小时按一小时计算</div>
            </div>
            <div>
                <div class="dialogTitle">· 路费：</div>
                <div class="dialogBody">· 基础路费：880円，实际路费超出部分将根据实际情况另外结算</div>
            </div>
            <div>
                <div class="dialogTitle">· 其他费用：</div>
                <div class="dialogBody">· 买办代办时发生的其他费用需提前预先支付，如有剩余将在订单结束时一并退还</div>
            </div>
            <div>
                <div class="dialogTitle">· 总费用示例：</div>
                <div class="dialogBody">· 1小时代办服务：2000円基本服务费 + 3300円服务费 + 880円路费 = 6180円</div>
                <div class="dialogBody">· 2小时跑腿服务：2000円基本服务费 + 6600円服务费 + 880円路费 = 9480円</div>
            </div>
            <div class="dialogRed">· 注：具体费用将根据服务项目和实际路程确定，详情请在预约时咨询。</div>
        </div>
        <div v-if="serveType=='chef-1'">
            <div slots="title" class="diaTitle">
                价格说明-私人厨师上门服务
                <span style="color: #999999;">（含税）</span>
            </div>
            <div>
                <div class="dialogTitle">· 价格收费说明（含税）：</div>
                <div class="dialogBody">· 服务收费：根据菜品种类和复杂度，费用从3630円/小时起</div>
                <div class="dialogBody">· 最少预订时长：2小时起订</div>
                <div class="dialogBody">· 交通费用：880円/每位厨师</div>
                <div class="dialogBody">· 服务人员数量：根据宴席规模或菜品种类，通常派遣1位或2位厨师，具体人数将视需求调整</div>
            </div>
            <div>
                <div class="dialogTitle">· 特别收费项目（视情况额外收费）：</div>
                <div class="dialogBody">· 高端食材：如需使用高级食材（例如松露、鹅肝、龙虾等），将按实际市场价格另行报价</div>
                <div class="dialogBody">· 国际风味餐：根据您选择的餐系及菜单复杂度，提供详细报价</div>
            </div>
            <div>
                <div class="dialogTitle">· 总费用示例：</div>
                <div class="dialogBody">· 2小时私人厨师服务（1人）：10000円 + 880円交通费 = 10880円</div>
                <div class="dialogBody">· 3小时家庭聚餐服务（2人）：15000円 + 1760円交通费 = 16760円</div>
            </div>
            <div class="dialogRed">· 注：所有私人厨师服务的具体价格和时长将根据菜单及食材需求进行调整，详情请在预约时咨询。</div>
        </div>
        <div v-if="serveType=='chef-2'">
            <div slots="title" class="diaTitle">
                价格说明-特殊餐饮服务
                <span style="color: #999999;">（含税）</span>
            </div>
            <div>
                <div class="dialogTitle">· 价格收费说明（含税）：</div>
                <div class="dialogBody">· 健康餐服务：根据菜单及食材选择，费用从6000円/每餐起</div>
                <div class="dialogBody">· 儿童餐服务：根据餐单设计，费用从5000円/每餐起</div>
                <div class="dialogBody">· 老年人餐饮：根据餐品复杂度，费用从5500円/每餐起</div>
                <div class="dialogBody">· 基础服务费：2000円</div>
                <div class="dialogBody">· 最少预订数量：1餐起订</div>
                <div class="dialogBody">· 交通费用：880円/每次配送</div>
            </div>
            <div>
                <div class="dialogTitle">· 特殊需求费用（视情况额外收费）：</div>
                <div class="dialogBody">· 个性化营养咨询：如需营养师提供饮食建议，费用另议</div>
            </div>
            <div>
                <div class="dialogTitle">· 总费用示例：</div>
                <div class="dialogBody">· 1份健康餐服务：6000円 + 2000円基础服务费 + 880円配送费 = 8880円</div>
                <div class="dialogBody">· 2份儿童餐服务：10000円 + 2000円基础服务费 + 880円配送费 = 12880円</div>
            </div>
            <div class="dialogRed">· 注：所有特殊餐饮服务的具体价格将根据客户需求和菜单进行调整，详情请在预约时咨询。</div>
        </div>
        <div v-if="serveType=='pets-1'">
            <div slots="title" class="diaTitle">
                价格说明-宠物喂养服务
                <span style="color: #999999;">（含税）</span>
            </div>
            <div>
                <div class="dialogTitle">· 价格收费说明（含税）：</div>
                <div class="dialogBody">· 宠物喂养服务：2800円/小时</div>
                <div class="dialogBody">· 交通费用：880円/每位服务人员</div>
            </div>
            <div>
                <div class="dialogTitle">· 总费用示例：</div>
                <div class="dialogBody">· 2小时宠物喂养服务：2800円 × 2小时 + 880円交通费 = 6480円</div>
                <div class="dialogBody">· 3小时宠物喂养服务：2800円 × 3小时 + 880円交通费 = 9280円</div>
            </div>
            <div class="dialogRed">· 注：所有宠物寄养服务的具体价格将根据宠物的需求和实际情况进行调整，详情请在预约时咨询。</div>
        </div>
        <div v-if="serveType=='pets-2'">
            <div slots="title" class="diaTitle">
                价格说明-遛狗服务
                <span style="color: #999999;">（含税）</span>
            </div>
            <div>
                <div class="dialogTitle">· 价格收费说明（含税）：</div>
                <div class="dialogBody">· 遛狗服务：2800円/小时。最少1小时起订</div>
                <div class="dialogBody">· 交通费用：880円/每位服务人员</div>
            </div>
            <div>
                <div class="dialogTitle">· 总费用示例：</div>
                <div class="dialogBody">· 1小时遛狗服务：2800円 + 880円交通费 = 3680円</div>
                <div class="dialogBody">· 1.5小时遛狗服务：2800円 × 1.5次 + 880円交通费 = 5080円</div>
            </div>
            <div class="dialogRed">· 注：所有遛狗服务的具体价格和时长将根据实际需求进行调整，详情请在预约时咨询。</div>
        </div>
        <div v-if="serveType=='repair-1'">
            <div slots="title" class="diaTitle">
                价格说明-安装服务
                <span style="color: #999999;">（含税）</span>
            </div>
            <div>
                <div class="dialogTitle">· 价格收费说明（含税）：</div>
                <div class="dialogBody">· 服务收费：收费价格详谈</div>
                <div class="dialogBody">· 最少预订时长：具体情况根据项目而定</div>
                <div class="dialogBody">· 交通费用：880円/每位服务人员</div>
                <div class="dialogBody">· 服务人员数量：通常派遣1位或2位服务人员，具体人数根据安装区域大小及确定</div>
            </div>
            <div class="dialogRed">· 注：所有安装项目的具体价格和时长将根据现场评估进行调整，详情请在预约时咨询。</div>
        </div>
        <div v-if="serveType=='repair-2'">
            <div slots="title" class="diaTitle">
                价格说明-维修服务
                <span style="color: #999999;">（含税）</span>
            </div>
            <div>
                <div class="dialogTitle">· 价格收费说明（含税）：</div>
                <div class="dialogBody">· 维修服务收费：根据具体维修项目的复杂度和所需材料，费用详谈</div>
                <div class="dialogBody">· 最少服务时长：具体情况根据项目而定</div>
                <div class="dialogBody">· 交通费用：880円/每位服务人员</div>
                <div class="dialogBody">· 服务人员数量：通常派遣1位或2位服务人员，具体人数根据维修项目的性质及规模确定</div>
            </div>
            <div class="dialogRed">· 注：所有维修项目的具体价格和时长将根据现场评估进行调整，详情请在预约时咨询。</div>
        </div>
    </el-dialog>

    <el-dialog
        v-model="showKefu"
        title=""
        :width="dialogWidth"
        center
    >
        <img style="width: 100%;height: auto;" src="../../assets/IG.png"/>
        <div style="text-align: center;font-size: 16px;">@OLLACLEAN</div>
        <div style="text-align: center;font-size: 16px;">IPHONE:07013191220</div>
    </el-dialog>

    <div class="phone">
        <div class="kefu">
            <div @click="openWx">IG客服</div>
            <div>接待时间：年中无休</div>
        </div>
        <div class="fanwei" @click="changeShowAddr">服务范围</div>
    </div>
</template>

<script>
import ollaHead from "@/components/zh/ollaHead.vue";

export default {
    name: "ollaIndex",
    components: {
        ollaHead
    },
    data() {
        return {
            serveType: "",
            showContext: false,
            showPrice: false,
            showAddr: false,
            showKefu: false,
            addrs: [
                {
                    city: "東京都",
                    areas: [
                        "中央区",
                        "千代田区",
                        "新宿区",
                        "港区",
                        "文京区",
                        "台東区",
                        "墨田区",
                        "江東区",
                        "品川区",
                        "目黒区",
                        "大田区",
                        "世田谷区",
                        "渋谷区",
                        "中野区",
                        "杉並区",
                        "北区",
                        "荒川区",
                        "板橋区",
                        "足立区",
                        "葛飾区",
                        "葛飾区",
                        "江戸川区",
                        "豊島区",
                        "武蔵野市",
                        "三鷹市",
                        "調布市",
                        "狛江市",
                        "府中市",
                        "国立市",
                        "国分寺",
                        "市立川市",
                        "小金井市",
                        "小平市",
                        "西東京市",
                        "町田市",
                        "多摩市",
                        "稲城市"
                    ]
                },
                {
                    city: "神奈川県",
                    areas: [
                        "中区",
                        "南区",
                        "西区",
                        "緑区",
                        "港北区",
                        "旭区",
                        "神奈川区",
                        "鶴見区",
                        "都筑区",
                        "保土ヶ谷区",
                        "都泉区",
                        "磯子区",
                        "金沢区",
                        "港南区",
                        "栄区",
                        "瀬谷区",
                        "戸塚区",
                        "川崎区",
                        "高津区",
                        "幸区",
                        "麻生区",
                        "中原区",
                        "宮前区",
                        "多摩区"
                    ]
                },
                {
                    city: "埼玉県",
                    areas: [
                        "北区",
                        "大宮区",
                        "見沼区",
                        "中央区",
                        "桜区",
                        "浦和区",
                        "南区",
                        "緑区",
                        "岩槻区"
                    ]
                }
            ],
            isScroll: "0",
            dialogWidth: "50vw",
        };
    },
    created() {
        this.setDialogWidth()
    },
    mounted() {
        document.title='您的海外生活助手'
        window.addEventListener('scroll', this.handleScroll);
        window.onresize = () => {
            return (() => {
                this.setDialogWidth()
            })()
        }
    },
    unmounted() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        setDialogWidth() {
            var val = document.body.clientWidth
            const def = 768 // 默认宽度
            if (val < def) {
                this.dialogWidth = '90vw';
            } else {
                this.dialogWidth = '50vw';
            }
        },
        handleScroll() {
            this.isScroll = window.scrollY > window.innerWidth * 0.1 ? "1" : "0";
        },
        scrollToAnchor(anchorId){
            const element = document.getElementById(anchorId);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        },
        changeShowAddr(){
            this.showAddr = true;
        },
        changeShowContext(_serveType){
            this.showContext = true;
            this.serveType = _serveType;
        },
        changeShowPrice(_serveType){
            this.showPrice = true;
            this.serveType = _serveType;
        },
        openWx(){
            this.showKefu = true;
        }
    }
}
</script>

<style scoped>
.d-f {
    display: flex;
}

.f-1 {
    flex: 1;
}
.p-r{
    position: relative;
}

.header {
    position: fixed;
    width: 100vw;
    height: 6vw;
    z-index: 1000;
    padding: 0;
    opacity: 1;
}

.indexMain {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    margin-top: 0px;
    padding: 0;
    overflow-x: hidden;
}

.main1 {
    position: relative;
    width: 100vw;
    height: 47.2vw;
    background-image: url("../../assets/top_bg.png");
    background-repeat: no-repeat;
    background-size: 100%;
}

.main1_t1 {
    position: absolute;
    top: 8vw;
    left: 0vw;
    width: 100vw;
    text-align: center;
    color: white;
    font-size: 2.8vw;
}

.main1_t2 {
    position: absolute;
    top: 18vw;
    left: 30vw;
    color: white;
    font-size: 1.25vw;
    width: 40vw;
    text-align: center;
}

.tabs {
    position: absolute;
    top: 40vw;
    right: 2.8vw;
    width: 53.5vw;
    height: 4.72vw;
    background-color: white;
    border-radius: 4px;
}

.main1_tab {
    display: flex;
    cursor: pointer;
    flex: 1;
    justify-content: center;
    justify-items: center;
    align-items: center;
}

.main1_tab img {
    width: 2.5vw;
    height: 2.5vw;
    margin-right: 0.8vw;
}

.tab_text {
    font-size: 1.1vw;
    font-weight: bold;
}

.tabTitle{
    margin-top: 2.8vw;
    justify-content: center;
    align-items: center;
}

.iconTitle {
    width: 1.1vw;
    height: 1.7vw;
}

.titleText {
    font-size: 2vw;
    line-height: 2.8vw;
    font-weight: bold;
    margin: 0 0.5vw;
}

.divSouji {
    margin-top: 3vw;
    width: 100vw;
}
.divSouji_d1{
    display: flex;
}

.soujiTop {
    position: relative;
    width: 50vw;
    height: 33.3vw;
    background: #FFFCFC;
}

.soujiTop img {
    position: absolute;
    left: 8vw;
    top: 5.7vw;
    width: 6vw;
    height: 7vw;
}

.soujiTop div:nth-child(2) {
    position: absolute;
    left: 8vw;
    top: 10vw;
    font-size: 1.5vw;
    font-weight: bold;
}

.soujiTop div:nth-child(3) {
    position: absolute;
    left: 8vw;
    top: 13.75vw;
    width: 33.75vw;
    font-size: 1vw;
    line-height: 1.7vw;
}

.contextImg {
    width: 50vw;
    height: 33.3vw;
}

.serveBoxs{
    display: flex;
    margin-top: 3.3vw;
    margin-left: 8vw;
}

.divSouji .serveBox {
    width: 26.7vw;
    height: 20.7vw;
    box-shadow: 0.2vw 0.2vw 0.8vw 0px rgba(0, 0, 0, 0.05);
    border-radius: 0.8vw;
    margin-right: 1.7vw;
}
.divSouji .serveBoxTop img{
    width: 100%;
    height: 100%;
}
.divSouji .serveBoxTop div{
    position: absolute;
}

.divSouji .serveBoxTop div:nth-child(2){
    top:8.3vw;
    left: 2.8vw;
    font-weight: bold;
    font-size: 1.25vw;
    color: white;
    line-height: 2vw;
}
.divSouji .serveBoxTop div:nth-child(3){
    top:8.3vw;
    right: 1.7vw;
    font-size: 1vw;
    color: black;
    text-align: center;

    background: rgba(255,255,255,0.7);
    border-radius: 1.1vw;
    width: 6vw;
    height: 2vw;
    line-height: 2vw;
}

.divSouji .serveBoxbottom{
    margin: 0 1.7vw;
}
.divSouji .serveContext{
    margin-top: 1.1vw;
    font-size: 0.8vw;
    line-height: 1.4vw;
    color: #666666;
}

.divSouji .servePrice{
    display: flex;
    margin-top: 0.85vw;
}

.servePrice div:nth-child(1){
    font-size: 0.85vw;
    color: rgba(74, 16, 18, 1);

    span{
        font-size: 1.25vw;
        font-weight: bold;
        color: rgba(255, 78, 82, 1);
    }
}

.servePrice div:nth-child(2){
    font-size: 0.85vw;
    color: rgba(102, 102, 102, 1);
    font-weight: bold;
}


.divRun {
    margin-top: 5.5vw;
    width: 100vw;
}

.runTop {
    position: relative;
    width: 50vw;
    height: 33.3vw;
    background: #FFFCFC;
}

.runTop img {
    position: absolute;
    left: 8vw;
    top: 5.7vw;
    width: 6vw;
    height: 7vw;
}

.runTop div:nth-child(2) {
    position: absolute;
    left: 8vw;
    top: 10vw;
    font-size: 1.5vw;
    font-weight: bold;
}

.runTop div:nth-child(3) {
    position: absolute;
    left: 8vw;
    top: 13.75vw;
    width: 33.75vw;
    font-size: 1vw;
    line-height: 1.7vw;
}

.divRun .serveBox {
    width: 40.8vw;
    height: 20.7vw;
    box-shadow: 0.2vw 0.2vw 0.8vw 0px rgba(0, 0, 0, 0.05);
    border-radius: 0.8vw;
    margin-right: 1.7vw;
}
.divRun .serveBoxTop img{
    width: 100%;
    height: 100%;
}
.divRun .serveBoxTop div{
    position: absolute;
}

.divRun .serveBoxTop div:nth-child(2){
    top:10vw;
    left: 2.8vw;
    font-weight: bold;
    font-size: 1.25vw;
    color: white;
    line-height: 2vw;
}
.divRun .serveBoxTop div:nth-child(3){
    top:10vw;
    right: 1.7vw;
    font-size: 1vw;
    color: black;
    text-align: center;

    background: rgba(255,255,255,0.7);
    border-radius: 1.1vw;
    width: 6vw;
    height: 2vw;
    line-height: 2vw;
}

.divRun .serveBoxbottom{
    margin: 0 1.7vw;
}
.divRun .serveContext{
    margin-top: 1.7vw;
    font-size: 0.8vw;
    line-height: 1.4vw;
    color: #666666;
}
.divRun .servePrice{
    display: flex;
    margin-top: 1.4vw;
}


.pets .serveBoxTop div:nth-child(2){
    top:8.5vw;
}
.pets .serveBoxTop div:nth-child(3){
    top:8.5vw;
}
.pets .serveContext{
    margin-top: 1.2vw;
}

.okerBottom{
    position: relative;
    margin-top: 3vw;
    width: 100vw;
    height: 28vw;
    background: #FFFCFC;

    .b_d1{
        position: absolute;
        left: 8vw;
        top: 9.8vw;
        font-weight: bold;
        font-size: 1.5vw;
    }
    .b_d2{
        position: absolute;
        width: 33.8vw;
        left: 8vw;
        top: 14vw;
        font-size: 1vw;
        line-height: 1.7vw;
        color: #666666;
    }

    .oker{
        position: absolute;
        left: 8vw;
        top: 5.8vw;
        width: 16.25vw;
        height: 7vw;
    }

    .qr_guanfang{
        position: absolute;
        left: 67.4vw;
        top: 9.5vw;
    }

    .qr_run{
        position: absolute;
        left: 81.25vw;
        top: 9.5vw;
    }

    .qr{
        text-align: center;
        img{
            width: 7vw;
            height: 7vw;
        }
        div{
            margin-top: 0.5vw;
            text-align: center;
            font-size: 1vw;
            color: #000000;
        }
    }
}

.diaTitle{
    text-align: center;
    font-weight: bold;
    font-size: 1vw;
}

.dialogCity{
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 1vw;
    line-height: 1.6vw;
    margin: 0 1vw;
}
.dialogArea{
    font-family: PingFang SC, PingFang SC;
    font-size: 0.8vw;
    color: #666666;
    line-height: 1.6vw;
    margin: 0 2vw;
    font-weight: 400;
}

.dialogTitle{
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 1vw;
    line-height: 1.6vw;
    margin: 0 1vw;
}
.dialogBody{
    font-family: PingFang SC, PingFang SC;
    font-size: 0.8vw;
    color: #666666;
    line-height: 1.6vw;
    margin: 0 2vw;
    font-weight: 400;
}

.dialogRed{
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 0.8vw;
    line-height: 1.6vw;
    margin: 0 1vw;
    color: #FF4E52;
}

.phone{
    display: none;
}

@media (max-width: 768px) {
    .header {
        height: 48px;
    }

    .main1 {
        background-image: url("../../assets/top_bg_phone.png")!important;
        height: 160vw!important;
    }
    .main1_t1{
        left: 16px;
        top: 150px;
        font-size: 20px;
    }
    .main1_t2{
        left: 16px;
        top: 232px;
        font-size: 14px;
        line-height: 22px;
        width: calc(100vw - 32px);
    }
    .tabs{
        top: calc(160vw - 44px);
        left: 16px;
        height: 88px;
        width: calc(100vw - 32px);
        box-shadow: 0.2vw 0.2vw 0.8vw 0px rgba(0, 0, 0, 0.05);
    }
    .main1_tab:nth-child(1){
        margin-left: 4vw;
    }
    .main1_tab:nth-child(5){
        margin-right: 4vw;
    }
    .main1_tab{
        display: block;
        text-align: center;
    }
    .main1_tab img{
        width: 32px!important;
        height: 32px!important;
        margin-top: 16px!important;
    }
    .main1_tab .tab_text{
        font-size: 14px;
        line-height: 24px;
        color: #4A1012;
    }
    .tabTitle{
        margin-top: 80px;
    }
    .tabTitle .iconTitle{
        width: 12px;
        height: 18px;
    }
    .tabTitle .titleText{
        font-size: 18px;
        line-height: 21px;
    }
    .divSouji_d1{
        display: block;
    }
    .soujiTop{
        width: 100vw;
        height: 180px;


    }
    .soujiTop div:nth-child(2){
        left: 28px;
        width: calc(100vw - 56px);
        font-size: 16px;
        line-height: 20px;
        top: 48px;
    }
    .soujiTop div:nth-child(3){
        left: 28px;
        width: calc(100vw - 56px);
        font-size: 12px;
        line-height: 20px;
        top: 86px;
    }
    .soujiTop img{
        width: 43px;
        height: 50px;
        left: 28px;
        top: 22px;
    }
    .contextImg{
        width: calc(100% - 32px);
        height: 66.9vw;
        margin-left: 16px;
        border-radius: 10px;
    }

    .runTop{
        width: 100vw;
        height: 200px;
    }
    .runTop div:nth-child(2){
        width: calc(100vw - 56px);
        left: 28px;
        font-size: 16px;
        line-height: 20px;
        top: 48px;
    }
    .runTop div:nth-child(3){
        width: calc(100vw - 56px);
        left: 28px;
        font-size: 12px;
        line-height: 20px;
        top: 86px;
    }
    .runTop img{
        width: 43px;
        height: 50px;
        left: 28px;
        top: 22px;
    }

    .serveBoxs{
        overflow-x: auto;
        margin-top: 24px;
        margin-left: 28px;
        display: -webkit-box;
    }
    .serveBox{
        width: 192px!important;
        height: auto!important;
        margin-right: 16px!important;
        border-radius: 15px!important;
    }
    .serveBoxTop{
        justify-content: center;
        overflow: hidden;
        height: 160px!important;
        border-radius: 15px 15px 0 0;
    }
    .serveBoxTop img{
        width: auto!important;
        border-radius: 15px 15px 0 0;
    }
    .serveBoxTop div:nth-child(2){
        left: 32px!important;
        top: 126px!important;
        font-size: 16px!important;
    }
    .serveBoxTop div:nth-child(3){
        top: 12px!important;
        right: 12px!important;
        width: 88px!important;
        height: 32px!important;
        font-size: 14px!important;
        line-height: 32px!important;
        border-radius: 20px!important;
    }
    .serveBoxbottom{
        margin: 0 16px!important;
    }
    .serveContext{
        font-size: 12px!important;
        line-height: 20px!important;
        margin-top: 16px!important;
    }
    .servePrice{
        display: block!important;
    }
    .servePrice div:nth-child(1){
        font-size: 10px;
        line-height: 12px;
        margin-top: 28px;
    }
    .servePrice div:nth-child(1) span{
        font-size: 16px!important;
        font-weight: bold!important;
        color: rgba(255, 78, 82, 1)!important;
    }
    .servePrice div:nth-child(2){
        font-size: 12px;
        margin-top: 10px;
        padding-bottom: 16px;
    }

    .okerBottom{
        height: 450px;
    }
    .okerBottom .oker{
        position: absolute;
        width: 117px!important;
        height: 50px!important;
        top: 24px!important;
        left: 28px!important;
    }
    .okerBottom .b_d1{
        position: absolute;
        top: 48px!important;
        left: 28px!important;
        font-size: 16px!important;
    }
    .okerBottom .b_d2{
        position: absolute;
        width: calc(100vw - 56px)!important;
        top: 90px!important;
        left: 28px!important;
        font-size: 12px!important;
        line-height: 20px!important;
    }
    .okerBottom .qr{
        text-align: center;
    }
    .okerBottom .qr img{
        width: 100px!important;
        height: 100px!important;
    }
    .okerBottom .qr div{
        font-size: 14px!important;
    }
    .okerBottom .qr_guanfang{
        position: absolute;
        top: 200px!important;
        left: 51px!important;
    }
    .okerBottom .qr_run{
        position: absolute;
        top: 200px!important;
        left: auto!important;
        right: 51px!important;
    }


    .diaTitle{
        font-size: 16px;
        margin-top: -30px;
    }

    .dialogCity{
        font-size: 14px;
        line-height: 28px;
        margin: 0 14px;
    }
    .dialogArea{
        font-size: 14px;
        line-height: 28px;
        margin: 0 24px;
        color: #999999;
    }

    .dialogTitle{
        font-size: 14px;
        line-height: 20px;
        margin: 5px 0;
    }
    .dialogBody{
        font-size: 14px;
        line-height: 20px;
        margin: 5px 12px;
        color: #999999;
    }

    .dialogRed{
        font-size: 12px;
        line-height: 20px;
        margin: 0 14px;
    }

    .phone{
        display: flex;
        position: fixed;
        bottom: 0;
        width: 100vw;
        height: 72px;
        background-color: white;
    }

    .kefu{
        text-align: center;
        background: rgba(255,78,82,0.12);
        border-radius: 20px;
        margin: 12px 12px 0 16px;
        height: 46px;
        width: calc(50vw - 28px);
    }
    .kefu div:nth-child(1){
        color: #FF4E52;
        font-weight: bold;
        font-size: 14px;
        line-height: 20px;
        margin-top: 6px;
    }
    .kefu div:nth-child(2){
        color: #999999;
        font-size: 10px;
        line-height: 14px;
    }

    .fanwei{
        cursor: pointer;
        text-align: center;
        background: #FF4E52;
        border-radius: 20px;
        color: white;
        margin: 12px 0 0 12px;
        height: 46px;
        width: calc(50vw - 28px);
        line-height: 46px;
        font-size: 14px;
    }
}
</style>
